import { render, staticRenderFns } from "./CheckBalance.vue?vue&type=template&id=f57e5680&"
import script from "./CheckBalance.vue?vue&type=script&lang=js&"
export * from "./CheckBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports